var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.374 5.6869H14.2174L9.47834 10.426L4.73926 5.6869H7.58271V0H11.374V5.6869Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3286 12.8257C18.1296 12.6133 16.8017 11.1926 16.4226 10.822C16.1569 10.5673 15.803 10.4253 15.435 10.4258H13.7696L16.6738 13.2635H13.3147C13.269 13.2627 13.224 13.2739 13.184 13.2961C13.1441 13.3182 13.1107 13.3505 13.0872 13.3896L12.3138 15.1649H6.64205L5.86864 13.3896C5.845 13.3506 5.81158 13.3184 5.77167 13.2963C5.73177 13.2742 5.68678 13.2629 5.64116 13.2635H2.28209L5.18526 10.4258H3.52089C3.14461 10.4258 2.78539 10.5765 2.53327 10.822C2.15414 11.1935 0.826247 12.6143 0.627206 12.8257C0.163723 13.3195 -0.0912399 13.7128 0.0300807 14.199L0.561806 17.1126C0.683127 17.5998 1.21675 17.9998 1.74847 17.9998H17.2093C17.741 17.9998 18.2746 17.5998 18.3959 17.1126L18.9277 14.199C19.0471 13.7128 18.7931 13.3195 18.3286 12.8257Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload2);
export default __webpack_public_path__ + "static/media/Download2.2da5b6c279ec8dcc887744846c3ccf02.svg";
export { ForwardRef as ReactComponent };